// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popup-wrapper[data-v-7dab2961]{width:100%;height:100%;background-color:#fff;position:fixed;top:0;left:0;z-index:4500;overflow:auto;padding:60px 15px 15px}.case-item+.case-item[data-v-7dab2961]{margin-top:15px}.cancel-btn[data-v-7dab2961]{border:0;background-color:#01426b;color:#fff;border-radius:30px;padding:2px 10px;margin-top:10px}", ""]);
// Exports
module.exports = exports;
